"use client"

import { useState } from "react"
import Image from "next/image"
import Link from "next/link"
import { motion } from "framer-motion"

// Collectors data
const collectors = [
  {
    id: "keepcase",
    name: "Erin",
    username: "Keepcase",
    twitterUrl: "https://x.com/Keepcase",
    avatar: "/images/collectors/keepcase-avatar.webp",
    tooltip: "Erin @Keepcase"
  },
  {
    id: "aoifeodwyer",
    name: "Aoife O'Dwyer",
    username: "aoifeodwyer",
    twitterUrl: "https://x.com/aoifeodwyer",
    avatar: "/images/collectors/aoifeodwyer-avatar.webp",
    tooltip: "Aoife O'Dwyer @aoifeodwyer"
  },
  {
    id: "artonblockchain",
    name: "Erick / Snowfro",
    username: "ArtOnBlockchain",
    twitterUrl: "https://x.com/ArtOnBlockchain",
    avatar: "/images/collectors/artonblockchain-avatar.webp",
    tooltip: "Erick / Snowfro @ArtOnBlockchain"
  },
  {
    id: "rodo",
    name: "Rodo",
    username: "0xRodo",
    twitterUrl: "https://x.com/0xRodo",
    avatar: "/images/collectors/rodo-avatar.webp",
    tooltip: "Rodo @0xRodo"
  }
]

export function MintedByCollectors() {
  const [hoveredCollector, setHoveredCollector] = useState<string | null>(null)
  
  // Framer Motion typing workaround for className support
  const MotionDiv: any = motion.div

  return (
    <MotionDiv
      className="w-full max-w-[384px] mx-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6, duration: 0.5 }}
    >
      <div className="flex items-center justify-center md:justify-between px-0 py-0 md:px-6 md:py-4 bg-transparent md:bg-gray-100/90 backdrop-blur-none md:backdrop-blur-sm rounded-none md:rounded-3xl">
        {/* "Minted by" label */}
        <div className="flex items-center">
          <span className="text-xs font-normal text-gray-500 uppercase tracking-wide">
            Minted by
          </span>
        </div>

        {/* Avatar stack */}
        <div className="flex items-center ml-3">
          <div className="flex -space-x-2">
            {collectors.map((collector, index) => (
              <div key={collector.id} className="relative">
                {/* Link to totems page */}
                <Link
                  href="/totems"
                  className="block relative group"
                  onMouseEnter={() => setHoveredCollector(collector.id)}
                  onMouseLeave={() => setHoveredCollector(null)}
                >
                  {/* Avatar */}
                  <div className="relative w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-white md:border-gray-100/90 bg-white overflow-hidden shadow-none duration-200">
                    <Image
                      src={collector.avatar}
                      alt={`${collector.name} avatar`}
                      fill
                      className="object-cover"
                      sizes="(max-width: 768px) 32px, 40px"
                    />
                  </div>

                  {/* Tooltip */}
                  {hoveredCollector === collector.id && (
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded-md whitespace-nowrap z-10 opacity-90">
                      {collector.tooltip}
                      {/* Tooltip arrow */}
                      <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900"></div>
                    </div>
                  )}
                </Link>
              </div>
            ))}
            
            {/* Badge with 100+ */}
            <div className="relative">
              <Link
                href="/totems"
                className="block relative group"
                onMouseEnter={() => setHoveredCollector("more")}
                onMouseLeave={() => setHoveredCollector(null)}
              >
                <div className="relative w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-white md:border-gray-100 bg-gradient-to-br from-violet-500 to-purple-600 shadow-none flex items-center justify-center">
                  <span className="text-white text-[10px] font-mono font-normal">100+</span>
                </div>

                {/* Tooltip */}
                {hoveredCollector === "more" && (
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded-md whitespace-nowrap z-10 opacity-90">
                    View all totems
                    {/* Tooltip arrow */}
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900"></div>
                  </div>
                )}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </MotionDiv>
  )
}
